import { c as _c } from "react/compiler-runtime";
import { Checkbox, FormInput, FormSelect, PrimaryButton, Tooltip } from '@systemeio/ui';
import { AddIcon } from '@systemeio/ui/icons';
import { addStudent } from 'modules/courses/courses/curriculum/api/students-api';
import { AccessTypeEnum } from 'modules/courses/courses/curriculum/enums/access-type-enum';
import { CourseCurriculumInterface } from 'modules/courses/courses/curriculum/types/curriculum-interface';
import { CreateStudentApiInterface, CreateStudentErrorsInterface, CreateStudentInterface } from 'modules/courses/courses/curriculum/types/student-interface';
import { CourseId } from 'modules/courses/courses/types/course-interface';
import { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { LightCourseCurriculumInterface } from '../../light-course/light-course-interface';
import { isPartialType } from '../utils/is-partial-type';
import { getCourseAccessTypeDataOptions } from '../utils/get-course-access-type-data-options';
const defaultValues: CreateStudentInterface = {
  firstName: '',
  lastName: '',
  email: '',
  accessType: AccessTypeEnum.fullAccess,
  modules: []
};
const defaultErrors: CreateStudentErrorsInterface = {
  fields: {
    firstName: '',
    lastName: '',
    email: '',
    accessType: ''
  }
};
function CreateStudentModal(t0) {
  const $ = _c(54);
  const {
    courseCurriculumData,
    courseId,
    disabledButton
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [errors, setErrors] = useState(defaultErrors);
  const [opened, setOpened] = useState(false);
  const {
    revalidateModules
  } = useRevalidateModules();
  let afterLeave;
  let handleCreate;
  let onClose;
  if ($[0] !== courseId || $[1] !== revalidateModules) {
    handleCreate = async data => {
      const studentData = {
        accessType: data.accessType || defaultValues.accessType,
        email: data.email,
        lastName: data.lastName || defaultValues.lastName,
        firstName: data.firstName || defaultValues.firstName,
        modules: isPartialType(data.accessType) ? data.modules : undefined
      };
      await fetchWithFieldErrors(async () => {
        await addStudent(courseId, studentData);
        onClose();
      }, setErrors);
      await revalidateModules([RequestModuleEnum.Students]);
    };
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => {
        setErrors(defaultErrors);
      };
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    afterLeave = t1;
    onClose = () => setOpened(false);
    $[0] = courseId;
    $[1] = revalidateModules;
    $[2] = afterLeave;
    $[3] = handleCreate;
    $[4] = onClose;
  } else {
    afterLeave = $[2];
    handleCreate = $[3];
    onClose = $[4];
  }
  const t1 = !disabledButton;
  let t2;
  if ($[6] !== t) {
    t2 = t("dashboard.course.add_student_modal.tooltip_text");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpened(true);
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = disabledButton || !courseCurriculumData;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AddIcon />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.course.add_student_modal.trigger_title");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="hidden whitespace-nowrap xl:block">{t6}</span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <PrimaryButton onClick={t3} disabled={t4}>{t5}{t7}</PrimaryButton>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t8) {
    t9 = <Tooltip disabled={t1} mode="hover" label={t2} stayOnHover={true}>{t8}</Tooltip>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("dashboard.students.title");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== errors || $[24] !== t) {
    t11 = {
      field: "firstName",
      onRender: (value, onChange) => <FormInput key="student-firstName" label={t("dashboard.user.first_name")} value={value} onChange={e => onChange(e.target.value)} error={errors.fields.firstName} />
    };
    $[23] = errors;
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== errors || $[27] !== t) {
    t12 = {
      field: "lastName",
      onRender: (value_0, onChange_0) => <FormInput key="student-lastName" label={t("dashboard.user.last_name")} value={value_0} onChange={e_0 => onChange_0(e_0.target.value)} error={errors.fields.lastName} />
    };
    $[26] = errors;
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== errors || $[30] !== t) {
    t13 = {
      field: "email",
      onRender: (value_1, onChange_1) => <FormInput key="student-email" label={t("global.email")} type="email" required={true} value={value_1} onChange={e_1 => onChange_1(e_1.target.value)} error={errors.fields.email} />
    };
    $[29] = errors;
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== errors || $[33] !== t) {
    t14 = {
      field: "accessType",
      onRender: (value_2, onChange_2) => <FormSelect key="student-accessType" className="sm:min-w-0" data={getCourseAccessTypeDataOptions(t)} label={t("dashboard.course.student_access_type_title")} required={true} value={value_2} onChange={value_3 => value_3 && onChange_2(value_3)} error={errors.fields.accessType} withoutCloseIcon={true} />
    };
    $[32] = errors;
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== courseCurriculumData) {
    t15 = {
      field: "modules",
      shouldRender: state => !!(isPartialType(state.accessType) && courseCurriculumData),
      onRender: (value_4, onChange_3, state_0) => <div key="student-accessType-modules">{isPartialType(state_0.accessType) && courseCurriculumData && <div className={`flex-col gap-1 text-sm font-medium ${courseCurriculumData.modules && courseCurriculumData.modules.length === 0 ? "hidden" : "flex"}`}><ul className="flex flex-row flex-wrap gap-5">{courseCurriculumData.modules.map(el => {
              const isSelected = value_4.includes(el.id);
              const label = el.name;
              return <li key={el.id}><Checkbox value={isSelected} label={<div className={`flex items-center gap-1.5 ${isSelected && "[&>svg]:fill-brand-primary [&>svg]:main-transition-colors"}`}>{label}</div>} onChange={() => isSelected ? onChange_3(value_4.filter(id => id !== el.id)) : onChange_3([...value_4, el.id])} /></li>;
            })}</ul></div>}</div>
    };
    $[35] = courseCurriculumData;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t15) {
    t16 = [t11, t12, t13, t14, t15];
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = ["email"];
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== afterLeave || $[45] !== handleCreate || $[46] !== onClose || $[47] !== opened || $[48] !== t10 || $[49] !== t16) {
    t18 = <CreateModal opened={opened} onClose={onClose} afterLeave={afterLeave} defaultValues={defaultValues} caption={t10} creatable={t16} onCreate={handleCreate} requiredFields={t17} />;
    $[44] = afterLeave;
    $[45] = handleCreate;
    $[46] = onClose;
    $[47] = opened;
    $[48] = t10;
    $[49] = t16;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t18 || $[52] !== t9) {
    t19 = <>{t9}{t18}</>;
    $[51] = t18;
    $[52] = t9;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
}
export default CreateStudentModal;